import echarts from 'echarts'

export default {
    "color": [
        new echarts.graphic.LinearGradient(
            0, 0, 1, 0, [{
                offset: 0,
                color: '#35C3FF'
            }, {
                offset: 1,
                color: '#18DDFF'
            }]
        ),
        new echarts.graphic.LinearGradient(
            0, 0, 1, 0, [{
                offset: 0,
                color: '#FACC14'
            }, {
                offset: 1,
                color: '#FBEC4E'
            }]
        ),
        "#1890ff",
        "#F0271C",
        "#2ec25b",
        "#5553CE",
        "#FE5788",
        "#13C2C2"
    ],
    "backgroundColor": "rgba(255,255,255,0)",
    "textStyle": {},
    "title": {
        "textStyle": {
            "fontSize": 12,
            "color": "#262626",
            "fontWeight": 'normal'
        },
        "subtextStyle": {
            "color": "#666666"
        }
    },
    "line": {
        "itemStyle": {
            "normal": {
                "borderWidth": "3"
            }
        },
        "lineStyle": {
            "normal": {
                "width": "3"
            }
        },
        "symbolSize": "12",
        "symbol": "none",
        "smooth": false
    },
    "radar": {
        "itemStyle": {
            "normal": {
                "borderWidth": "3"
            }
        },
        "lineStyle": {
            "normal": {
                "width": "3"
            }
        },
        "symbolSize": "12",
        "symbol": "none",
        "smooth": false
    },
    "bar": {
        "itemStyle": {
            "normal": {
                "barBorderWidth": 0,
                "barBorderColor": "#ccc"
            },
            "emphasis": {
                "barBorderWidth": 0,
                "barBorderColor": "#ccc"
            }
        }
    },
    "pie": {
        "itemStyle": {
            "normal": {
                "borderWidth": 0,
                "borderColor": "#ccc"
            },
            "emphasis": {
                "borderWidth": 0,
                "borderColor": "#ccc"
            }
        }
    },
    "scatter": {
        "itemStyle": {
            "normal": {
                "borderWidth": 0,
                "borderColor": "#ccc"
            },
            "emphasis": {
                "borderWidth": 0,
                "borderColor": "#ccc"
            }
        }
    },
    "boxplot": {
        "itemStyle": {
            "normal": {
                "borderWidth": 0,
                "borderColor": "#ccc"
            },
            "emphasis": {
                "borderWidth": 0,
                "borderColor": "#ccc"
            }
        }
    },
    "parallel": {
        "itemStyle": {
            "normal": {
                "borderWidth": 0,
                "borderColor": "#ccc"
            },
            "emphasis": {
                "borderWidth": 0,
                "borderColor": "#ccc"
            }
        }
    },
    "sankey": {
        "itemStyle": {
            "normal": {
                "borderWidth": 0,
                "borderColor": "#ccc"
            },
            "emphasis": {
                "borderWidth": 0,
                "borderColor": "#ccc"
            }
        }
    },
    "funnel": {
        "itemStyle": {
            "normal": {
                "borderWidth": 0,
                "borderColor": "#ccc"
            },
            "emphasis": {
                "borderWidth": 0,
                "borderColor": "#ccc"
            }
        }
    },
    "gauge": {
        "itemStyle": {
            "normal": {
                "borderWidth": 0,
                "borderColor": "#ccc"
            },
            "emphasis": {
                "borderWidth": 0,
                "borderColor": "#ccc"
            }
        }
    },
    "candlestick": {
        "itemStyle": {
            "normal": {
                "color": "#d0648a",
                "color0": "transparent",
                "borderColor": "#d0648a",
                "borderColor0": "#22c3aa",
                "borderWidth": "1"
            }
        }
    },
    "graph": {
        "itemStyle": {
            "normal": {
                "borderWidth": 0,
                "borderColor": "#ccc"
            }
        },
        "lineStyle": {
            "normal": {
                "width": "1",
                "color": "#cccccc"
            }
        },
        "symbolSize": "12",
        "symbol": "none",
        "smooth": false,
        "color": [
            "#1890ff",
            "#2ec25b",
            "#facc14",
            "#ef4864",
            "#9760e5",
            "#f2b3c9"
        ],
        "label": {
            "normal": {
                "textStyle": {
                    "color": "#ffffff"
                }
            }
        }
    },
    "map": {
        "itemStyle": {
            "normal": {
                "areaColor": "#eeeeee",
                "borderColor": "#999999",
                "borderWidth": 0.5
            },
            "emphasis": {
                "areaColor": "rgba(34,195,170,0.25)",
                "borderColor": "#22c3aa",
                "borderWidth": 1
            }
        },
        "label": {
            "normal": {
                "textStyle": {
                    "color": "#28544e"
                }
            },
            "emphasis": {
                "textStyle": {
                    "color": "rgb(52,158,142)"
                }
            }
        }
    },
    "geo": {
        "itemStyle": {
            "normal": {
                "areaColor": "#eeeeee",
                "borderColor": "#999999",
                "borderWidth": 0.5
            },
            "emphasis": {
                "areaColor": "rgba(34,195,170,0.25)",
                "borderColor": "#22c3aa",
                "borderWidth": 1
            }
        },
        "label": {
            "normal": {
                "textStyle": {
                    "color": "#28544e"
                }
            },
            "emphasis": {
                "textStyle": {
                    "color": "rgb(52,158,142)"
                }
            }
        }
    },
    "categoryAxis": {
        "axisLine": {
            "show": true,
            "lineStyle": {
                "color": "rgba(0,0,0,0.5)"
            }
        },
        "axisTick": {
            "show": true,
            "lineStyle": {
                "color": "rgba(0,0,0,0.5)"
            }
        },
        "axisLabel": {
            "show": true,
            "textStyle": {
                "color": "rgba(0,0,0,0.65)"
            }
        },
        "splitLine": {
            "show": false,
            "lineStyle": {
                "color": [
                    "#ededed"
                ]
            }
        },
        "splitArea": {
            "show": false,
            "areaStyle": {
                "color": [
                    "rgba(250,250,250,0.05)",
                    "rgba(200,200,200,0.02)"
                ]
            }
        }
    },
    "valueAxis": {
        "axisLine": {
            "show": false,
            "lineStyle": {
                "color": "#cccccc"
            }
        },
        "axisTick": {
            "show": false,
            "lineStyle": {
                "color": "#ededed"
            }
        },
        "axisLabel": {
            "show": true,
            "textStyle": {
                "color": "rgba(0,0,0,0.65)"
            }
        },
        "splitLine": {
            "show": true,
            "lineStyle": {
                "color": [
                    "#E8E8E8"
                ]
            }
        },
        "splitArea": {
            "show": false,
            "areaStyle": {
                "color": [
                    "rgba(250,250,250,0.05)",
                    "rgba(200,200,200,0.02)"
                ]
            }
        }
    },
    "logAxis": {
        "axisLine": {
            "show": true,
            "lineStyle": {
                "color": "#cccccc"
            }
        },
        "axisTick": {
            "show": true,
            "lineStyle": {
                "color": "#ededed"
            }
        },
        "axisLabel": {
            "show": true,
            "textStyle": {
                "color": "rgba(0,0,0,0.65)"
            }
        },
        "splitLine": {
            "show": true,
            "lineStyle": {
                "color": [
                    "#ededed"
                ]
            }
        },
        "splitArea": {
            "show": false,
            "areaStyle": {
                "color": [
                    "rgba(250,250,250,0.05)",
                    "rgba(200,200,200,0.02)"
                ]
            }
        }
    },
    "timeAxis": {
        "axisLine": {
            "show": true,
            "lineStyle": {
                "color": "#cccccc"
            }
        },
        "axisTick": {
            "show": true,
            "lineStyle": {
                "color": "#ededed"
            }
        },
        "axisLabel": {
            "show": true,
            "textStyle": {
                "color": "rgba(0,0,0,0.65)"
            }
        },
        "splitLine": {
            "show": true,
            "lineStyle": {
                "color": [
                    "#ededed"
                ]
            }
        },
        "splitArea": {
            "show": false,
            "areaStyle": {
                "color": [
                    "rgba(250,250,250,0.05)",
                    "rgba(200,200,200,0.02)"
                ]
            }
        }
    },
    "toolbox": {
        "iconStyle": {
            "normal": {
                "borderColor": "#999999"
            },
            "emphasis": {
                "borderColor": "#666666"
            }
        }
    },
    "legend": {
        "textStyle": {
            "color": "#666666"
        }
    },
    "tooltip": {
        "axisPointer": {
            "lineStyle": {
                "color": "#cccccc",
                "width": 1
            },
            "crossStyle": {
                "color": "#cccccc",
                "width": 1
            }
        }
    },
    "timeline": {
        "lineStyle": {
            "color": "#4ea397",
            "width": 1
        },
        "itemStyle": {
            "normal": {
                "color": "#4ea397",
                "borderWidth": 1
            },
            "emphasis": {
                "color": "#4ea397"
            }
        },
        "controlStyle": {
            "normal": {
                "color": "#4ea397",
                "borderColor": "#4ea397",
                "borderWidth": 0.5
            },
            "emphasis": {
                "color": "#4ea397",
                "borderColor": "#4ea397",
                "borderWidth": 0.5
            }
        },
        "checkpointStyle": {
            "color": "#4ea397",
            "borderColor": "rgba(60,235,210,0.3)"
        },
        "label": {
            "normal": {
                "textStyle": {
                    "color": "#4ea397"
                }
            },
            "emphasis": {
                "textStyle": {
                    "color": "#4ea397"
                }
            }
        }
    },
    "visualMap": {
        "color": [
            "#ff0000",
            "#60cfbe",
            "#adfff1"
        ]
    },
    "dataZoom": {
        "backgroundColor": "rgba(255,255,255,0)",
        "dataBackgroundColor": "rgba(222,222,222,1)",
        "fillerColor": "rgba(114,230,212,0.25)",
        "handleColor": "#cccccc",
        "handleSize": "100%",
        "textStyle": {
            "color": "#999999"
        }
    },
    "markPoint": {
        "label": {
            "normal": {
                "textStyle": {
                    "color": "#ffffff"
                }
            },
            "emphasis": {
                "textStyle": {
                    "color": "#ffffff"
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/charts/themes/energyOption_bar.js